import BasicProfileForm from './BasicProfileForm';

export default BasicProfileForm;


// WEBPACK FOOTER //
// ./src/components/forms/BasicProfileForm/index.js